import { render } from "./OtherWorkLineup.vue?vue&type=template&id=0270c60e&scoped=true"
import script from "./OtherWorkLineup.vue?vue&type=script&lang=js"
export * from "./OtherWorkLineup.vue?vue&type=script&lang=js"

import "./OtherWorkLineup.vue?vue&type=style&index=0&id=0270c60e&scoped=true&lang=css"

import exportComponent from "/Users/tamotsu/Documents/たもつ製作所/jibi/jibi-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0270c60e"]])

export default __exports__